import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ThemeService } from '../../_helpers/theming-engine/theme.service';
import { FeatureHelperService } from '../../_helpers/feature-helper/feature-helper.service';
import { SessionUserHashManagerService } from '../../_services/session-user-hash-manager/session-user-hash-manager.service';
import { StudentFeedbackService } from '../../_services/student-feedback/student-feedback.service';
import { ExternalStudentQuestionnaireInfoRequest } from '../../_models/student-feedback/external-student-questionnaire-info-request.model';
import { ToastService } from '../../_services';
import { ErrorModalHelperService } from '../../_helpers/error-modal-helper/error-modal-helper.service';
import { FeedbackSurvey } from '../../_models/student-feedback/feedback-survey.model';
import { ThankYouBannerComponent } from '../../shared/thank-you-banner/thank-you-banner.component';

@Component({
    selector: 'external-student-feedback',
    templateUrl: './external-student-feedback.component.html',
    styleUrls: ['./external-student-feedback.component.css'],
    standalone: false
})
export class ExternalStudentFeedbackComponent implements OnInit, OnDestroy {
  @ViewChild(ThankYouBannerComponent, {static: true}) private thankYouBanner!: ThankYouBannerComponent;

  public requestGuid: string;
  public initialLoadComplete: boolean = false;
  public submitted: boolean = false;

  public studentId: number;
  public bookingId: string;
  public startDate: Date;
  public endDate: Date
  public subject: string
  public feedbackSurvey: FeedbackSurvey = new FeedbackSurvey();

  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public themeService: ThemeService,
    private featureHelperService: FeatureHelperService,
    private router: Router,
    private route: ActivatedRoute,
    private userHashManager: SessionUserHashManagerService,
    public feedbackService: StudentFeedbackService,
    private toast: ToastService,
    private errorModalHelper: ErrorModalHelperService
    ) { 
      this.route.params.pipe(takeUntil(this.unsubscribe)).subscribe(params => {
        if (!params['guid']) {
          this.router.navigate(['/login']);
        } else {
          //this.userHashManager.checkUserForExternal();

          this.themeService.setActiveTheme('LEAP', false);

          // let featureList = new Array<string>();
          // featureList.push("BookingSearchView");

          // let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

          // if (!currentUserFeatures.filter(f => f.feature === "BookingSearchView")[0].enabled) {
          //   console.error("User does not have the required permissions to view Booking Search");
          //   this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname }});
          // }

          this.requestGuid = params['guid'];
         this.getStudentFeedbackQuestionnaireInfo();
        }
      });
    }

  ngOnInit() {
    
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public feedbackSubmitted(submitted: boolean): void {
    if (submitted) {
      this.submitted = true;
      setTimeout(() => {
        this.thankYouBanner.generateBanner();
      }, 100);
    } else {
      if (this.thankYouBanner) {
        this.thankYouBanner.removeBanner();
      }
      this.submitted = false;
    }
  }

  private getStudentFeedbackQuestionnaireInfo(): void {
    this.feedbackService.getStudentQuestionnaireInfoFromGuid(this.requestGuid).subscribe((result: ExternalStudentQuestionnaireInfoRequest) => {
      this.studentId = result.userId;
      this.bookingId = result.bookingId;
      this.startDate = result.startDate;
      this.endDate = result.endDate;
      this.subject = result.subject;

      this.feedbackSurvey = result.feedbackSurvey;

      this.initialLoadComplete = true;


    },
    error => {
      if (error.status === 401) {
        this.router.navigate(['/login']);
      }
      else {
        this.errorModalHelper.show(error.message, error);
      }
    });
  }

}
